import { render, staticRenderFns } from "./link-select-text.vue?vue&type=template&id=70f870ba&"
import script from "./link-select-text.vue?vue&type=script&lang=js&"
export * from "./link-select-text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports